import { Box, Paper, Stack, Typography } from "@mui/material";
import CustomTextField from "../../../../../../../components/common/Textfield";
import { useState } from "react";

interface ClientDetailsSectionProps {
  defaultValues?: {
    clientName?: string;
    email?: string;
    phone?: string;
    address?: string;
    deceasedName?: string;
  };
  onChange?: (values: {
  clientName: string;
  email: string;
  phone: string;
  address: string;
  deceasedName: string;
}) => void;
}

export default function ClientDetailsSection({
  defaultValues,
  onChange,
}: ClientDetailsSectionProps) {
  const [clientName, setClientName] = useState(defaultValues?.clientName ?? "");
const [email, setEmail] = useState(defaultValues?.email ?? "");
const [phone, setPhone] = useState(defaultValues?.phone ?? "");
const [address, setAddress] = useState(defaultValues?.address ?? "");
const [deceasedName, setDeceasedName] = useState(defaultValues?.deceasedName ?? "");

const handleChange = (field: string, value: string) => {
  const setters: Record<string, (v: string) => void> = {
    clientName: setClientName,
    email: setEmail,
    phone: setPhone,
    address: setAddress,
    deceasedName: setDeceasedName,
  };
  setters[field]?.(value);
  onChange?.({ clientName, email, phone, address, deceasedName, [field]: value });
};
  return (
    <Paper sx={{ borderRadius: "14px", p: 2.5, boxShadow: 0, mb: 2 }}>
      <Typography
        sx={{ fontWeight: 700, fontSize: "15px", color: "#1e293b", mb: 2 }}
      >
        Client Details
      </Typography>

      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: "11px", color: "#64748b", mb: 0.5 }}>
              Client Name
            </Typography>
            <CustomTextField
              value={clientName}
              onChange={(e) => handleChange("clientName", e.target.value)}
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  bgcolor: "#f8fafc",
                  fontSize: "12px",
                },
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: "11px", color: "#64748b", mb: 0.5 }}>
              Email
            </Typography>
            <CustomTextField
              value={email}
              onChange={(e) => handleChange("email", e.target.value)}
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  bgcolor: "#f8fafc",
                  fontSize: "12px",
                },
              }}
            />
          </Box>
        </Stack>

        <Box>
          <Typography sx={{ fontSize: "11px", color: "#64748b", mb: 0.5 }}>
            Deceased Name
          </Typography>
          <CustomTextField
            value={deceasedName}
            onChange={(e) => handleChange("deceasedName", e.target.value)}
            size="small"
            fullWidth
            InputProps={{ readOnly: true }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                bgcolor: "#f8fafc",
                fontSize: "12px",
              },
            }}
          />
        </Box>

        <Stack direction="row" spacing={2}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: "11px", color: "#64748b", mb: 0.5 }}>
              Phone
            </Typography>
            <CustomTextField
              value={phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  bgcolor: "#f8fafc",
                  fontSize: "12px",
                },
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: "11px", color: "#64748b", mb: 0.5 }}>
              Address
            </Typography>
            <CustomTextField
              value={address}
              onChange={(e) => handleChange("address", e.target.value)}
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  bgcolor: "#f8fafc",
                  fontSize: "12px",
                },
              }}
            />
          </Box>
        </Stack>
      </Stack>
    </Paper>
  );
}